"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetDefinition = void 0;
const zod_1 = require("zod");
const image_media_1 = require("./image-media");
const title_1 = require("./title");
const types = ['img', 'title'];
exports.AssetDefinition = zod_1.z
    .object({
    id: zod_1.z.number(),
    required: zod_1.z.number().optional(),
    img: image_media_1.ImageMedia.optional(),
    title: title_1.Title.optional(),
})
    .refine(asset => Object.keys(asset).filter(k => types.includes(k)).length === 1, {
    message: 'An asset must have exactly one type defined',
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXNzZXQtZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9lbnRpdGllcy9hc3NldC1kZWZpbml0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLDZCQUF1QjtBQUV2QiwrQ0FBMEM7QUFDMUMsbUNBQStCO0FBRS9CLE1BQU0sS0FBSyxHQUFHLENBQUMsS0FBSyxFQUFFLE9BQU8sQ0FBQyxDQUFBO0FBQ2pCLFFBQUEsZUFBZSxHQUFHLE9BQUM7S0FDN0IsTUFBTSxDQUFDO0lBQ04sRUFBRSxFQUFFLE9BQUMsQ0FBQyxNQUFNLEVBQUU7SUFDZCxRQUFRLEVBQUUsT0FBQyxDQUFDLE1BQU0sRUFBRSxDQUFDLFFBQVEsRUFBRTtJQUMvQixHQUFHLEVBQUUsd0JBQVUsQ0FBQyxRQUFRLEVBQUU7SUFDMUIsS0FBSyxFQUFFLGFBQUssQ0FBQyxRQUFRLEVBQUU7Q0FDeEIsQ0FBQztLQUNELE1BQU0sQ0FBQyxLQUFLLENBQUMsRUFBRSxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsS0FBSyxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLE1BQU0sS0FBSyxDQUFDLEVBQUU7SUFDL0UsT0FBTyxFQUFFLDZDQUE2QztDQUN2RCxDQUFDLENBQUEifQ==